import { render, staticRenderFns } from "./AdjuntosLista.vue?vue&type=template&id=3d4c0d96&scoped=true"
import script from "./AdjuntosLista.vue?vue&type=script&lang=js"
export * from "./AdjuntosLista.vue?vue&type=script&lang=js"
import style0 from "./AdjuntosLista.vue?vue&type=style&index=0&id=3d4c0d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c0d96",
  null
  
)

export default component.exports